let allGuys = [], index = 0, respawn;

export function setReset(r) {
    respawn = r
}

export function setGuys(arr) {
    allGuys = arr;
}

export function nextGuy() {
    let Guy = allGuys[index]
    index++;
    if (index >= allGuys.length) {
        index = 0;
    }
    return Guy;
}

export function setTick() {
    let obj = nextGuy();

    let spell = obj.spells[0]
    obj.ctick += obj.attr[spell.speed[0].id];

    if (obj.passive.length > 1) {
        for (let passive of obj.passive) {
            if (passive.type == "tick") {
                let reg = obj.attr[passive.from[0].id] * passive.proflevel[passive.level].mod / 10;
                passive.getExp(reg)
                obj.heal(reg);
            }
        }
    }

    obj.buffs.map(x => x.cast(obj))
    checkDead(obj);

    if (obj.ctick > obj.initative) {
        obj.ctick = 0;
        turn(obj)
    }
}

function turn(obj) {
    let spell = getNextSpell(obj)
    castSpell(obj, spell)
}

function getNextSpell(obj) {
    let spell = obj.spells[0]
    obj.spells.push(obj.spells.shift());
    return spell;
}

function getNextEnemy(good) {
    return allGuys.filter(x => x.bad == good)[0]
}

function castSpell(obj, spell) {
    let enemy = getNextEnemy(!obj.bad)
    spell.cast(obj, enemy);
    checkDead(enemy);
}

function checkDead(obj) {
    obj.isDead() && respawn(!obj.bad);
}

export function getDiff(timestamp) {
    let date = new Date(timestamp);
    return (new Date().getTime() - date.getTime()) / 100;
}

let clock = 0, start = Date.now();

export function setClock(time) {
    clock = time * -1;
}

export function checkUnfocusTime(update) {
    var now = Date.now();
    clock += 100;
    var dif = now - start - clock;

    while (dif >= 100) {
        update();
        clock += 100;
        dif -= 100;
    }
}